import { Button } from "../components/Button";
import { PhotoGrid } from "../components/PhotoGrid";
import { useFlow } from "../flow/FlowContext";
import { PHOTO_MAX, PHOTO_MIN } from "../media/limits";
import { useT } from "../i18n";

export function VerifyPhotosScreen() {
  const { answers, addPhotos, removePhoto, next, canContinue, userId } = useFlow();
  const t = useT();

  return (
    <>
      <div className="prompt screen-enter">
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("verify.photos.eyebrow")}</div>
          <h1 className="screen-head__title">{t("verify.photos.title")}</h1>
          <p className="screen-head__text">
            {t("verify.photos.text", { min: PHOTO_MIN, max: PHOTO_MAX })}
          </p>
        </header>
        <PhotoGrid
          photos={answers.profilePhotos}
          userId={userId ?? ""}
          onAdd={addPhotos}
          onRemove={removePhoto}
        />
      </div>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next} disabled={!canContinue}>
          {t("common.next")}
        </Button>
      </div>
    </>
  );
}
